import { jtBillingUrl } from '../../api/client';
import { useMarketingContactUsage } from '../../api/marketing-contacts.api';

const number = (n: number) => n.toLocaleString('en-AU');

/**
 * Marketing contacts used this billing month against what the organisation has paid for, with a
 * link to buy more in JobTetris (JT1-1867). JobTetris sells them in packs of 1,000 a month, and the
 * month counts everyone who was a marketing contact at any point in it (JT1-1865).
 */
export function MarketingContactUsage() {
  const { data } = useMarketingContactUsage();
  if (!data) return null;

  const buyLink = (label: string) => (
    <a href={jtBillingUrl()} target="_blank" rel="noreferrer" style={{ color: 'var(--color-text-brand)', fontWeight: 'var(--font-weight-medium)' }}>
      {label}
    </a>
  );

  const style = { fontFamily: 'var(--font-sans)', fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' };

  if (data.limit === null) {
    return <div style={style}>{number(data.used)} used this billing month</div>;
  }

  if (data.limit === 0) {
    return (
      <div style={style}>
        Your organisation needs a marketing-contact pack to add marketing contacts. {buyLink('Buy a pack in JobTetris')}
      </div>
    );
  }

  return (
    <div style={style}>
      {number(data.used)} of {number(data.limit)} used this billing month · {buyLink('Buy more')}
    </div>
  );
}
